export default "__VITE_ASSET__BH65s6Wm__"